import {useDispatch,useSelector} from 'react-redux';
const Language = () =>{
    const dispatch = useDispatch();
    const updatelanguage = (e) =>{
        let lan = e.target.value;
        dispatch({type:lan});
    }

    return(
          <div className="card">
            <div className='card-body'>
                <label><b>Update Language</b></label> 
                <br/>
                <br/>
                <div className='col-md-3'>
                    <select className='form-control' onChange={updatelanguage}>
                        <option value="en">English</option>
                        <option value="hi">Hindi</option>
                    </select>      
                </div> 
            </div> 
         </div>
    );  
}
export default Language;
